import { lazy } from '@loadable/component';

const Receipt = lazy(() =>
  import(
    /* webpackChunkName: "receipt" */
    './receipt'
  )
);

export default Receipt;
